// const _date_cur_date = new Date()
const DateRegAll = /^[12][0-9]{3}(-|\/)(0?[0-9]|1[0-2])(-|\/)(0?[1-9]|[1-2][0-9]|3[0-1]).(0?[0-9]|1[0-9]|2[0-3]):(0?[0-9]|[1-5][0-9]):(0?[0-9]|[1-5][0-9])$/
const DateRegYearMonth = /^[12][0-9]{3}(-|\/)(0?[0-9]|1[0-2])$/
const DateRegYearMonthDate = /^[12][0-9]{3}(-|\/)(0?[0-9]|1[0-2])(-|\/)(0?[1-9]|[1-2][0-9]|3[0-1])$/
const DateRegYearMonthDateHour = /^[12][0-9]{3}(-|\/)(0?[0-9]|1[0-2])(-|\/)(0?[1-9]|[1-2][0-9]|3[0-1]).(0?[0-9]|1[0-9]|2[0-3])$/
const DateRegYearMonthMateHourMinute = /^[12][0-9]{3}(-|\/)(0?[0-9]|1[0-2])(-|\/)(0?[1-9]|[1-2][0-9]|3[0-1]).(0?[0-9]|1[0-9]|2[0-3]):(0?[0-9]|[1-5][0-9])$/
const DateRegTime = /^(0?[0-9]|1[0-9]|2[0-3]):(0?[0-9]|[1-5][0-9]):(0?[0-9]|[1-5][0-9])$/

/***
 * @param {Object|Number|String} date
 * @param {Object} format
 */
export function getDate (date, format) {
  let now = toJsDate(date)
  let year = now.getFullYear()
  let month = (now.getMonth() + 1)
  let day = now.getDate()
  let hour = now.getHours()
  let minute = now.getMinutes()
  let second = now.getSeconds()
  let result
  let fill = function (val) {
    return (val < 10 ? '0' : '') + val
  }
  month = fill(month)
  day = fill(day)
  hour = fill(hour)
  minute = fill(minute)
  second = fill(second)

  if (!format) {
    format = 'YY-MM-DD HH:MM:SS'
  }

  switch (format) {
    case 'YY-MM':
      result = year + '-' + month
      break
    case 'MM-DD':
      result = month + '-' + day
      break
    case 'YY-MM-DD':
      result = year + '-' + month + '-' + day
      break
    case 'YY-MM-DD HH:MM:SS':
      result = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
      break
    case 'YY-MM-DD HH:MM':
      result = year + '-' + month + '-' + day + ' ' + hour + ':' + minute
      break
    case 'YY/MM/DD HH:MM':
      result = year + '/' + month + '/' + day + ' ' + hour + ':' + minute
      break
    case 'HH:MM':
      result = hour + ':' + minute
      break
    case 'HH:MM:SS':
      result = hour + ':' + minute + ':' + second
      break
    default:
      result = year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second
  }
  return result
}
// 以后所有的时间都从这块来, 这块的时间将会配合时间矫正来处理.
export function getNow () {
  return new Date()
}
// 转化成为js 的时间
export function toJsDate (date) {
  if (!isDate(date)) {
    return getNow()
  }
  if (typeof date === 'string') {
    date = date.replace(/-/g, '\\/')
    if (DateRegYearMonth.test(date)) {
      date += '/01'
    }
  }
  return new Date(date)
}
/**
 *
 * @param {Object|Number|String} oldDate
 * @param {String|Number} changeDate
 *                    Number+    y|mo|d|h|m|s 分别表示年/月/日/小时/分/秒.  如果没带后缀, 则默认为天.
 */
export function getDiffDate (oldDate, changeDate, format) {
  let curDate = toJsDate(oldDate)
  if (/^(-?\d+)y$/.test(changeDate)) {
    curDate.setYear(curDate.getYear() + (+RegExp.$1))
  } else if (/^(-?\d+)mo$/.test(changeDate) && RegExp.$1 != 0) {
        // 缓存当前的天
    let CacheDay = curDate.getDate()

        // 重置到月初. 如果当前的 getDate() 大于目标月的最大日期就悲剧了
    curDate.setDate(1)

        // 设置月份
    curDate.setMonth(curDate.getMonth() + (+RegExp.$1))
    curDate.setDate(CacheDay)

    if (curDate.getDate() != CacheDay) {
            // 上个月的最后一天
      curDate.setDate(0)
    }
  } else if (/^(-?\d+)d$/.test(changeDate)) {
    curDate.setDate(curDate.getDate() + (+RegExp.$1))
  } else if (/^(-?\d+)h$/.test(changeDate)) {
    curDate.setHours(curDate.getHours() + (+RegExp.$1))
  } else if (/^(-?\d+)m$/.test(changeDate)) {
    curDate.setMinutes(curDate.getMinutes() + (+RegExp.$1))
  } else if (/^(-?\d+)s$/.test(changeDate)) {
    curDate.setSeconds(curDate.getSeconds() + (+RegExp.$1))
  }
  return getDate(curDate, format)
}
export function formatDate (date) {
  if (!date || !isDate(date)) {
    return false
  }
  if (DateRegTime.test(date)) {
    return date.replace(/-/g, '\\//')
  } else {
    return getDate(date)
  }
}
export function isDate (date) {
  if (!date || date === null) {
    return false
  }
  if (typeof date === 'string') {
    return DateRegAll.test(date) ||
            DateRegYearMonth.test(date) ||
            DateRegYearMonthDate.test(date) ||
            DateRegYearMonthDateHour.test(date) ||
            DateRegYearMonthMateHourMinute.test(date)
  }
  let newDate = new Date(date)
  return newDate != 'Invalid Date'
}
